// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3g9Iv","topBottomGutter":"Layout_topBottomGutter__2GfZT"};